/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendAMessageInAConversationRequest
 */
export interface SendAMessageInAConversationRequest {
    /**
     * Must not be greater than 5000 characters.
     * @type {string}
     * @memberof SendAMessageInAConversationRequest
     */
    body: string;
}

/**
 * Check if a given object implements the SendAMessageInAConversationRequest interface.
 */
export function instanceOfSendAMessageInAConversationRequest(value: object): value is SendAMessageInAConversationRequest {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function SendAMessageInAConversationRequestFromJSON(json: any): SendAMessageInAConversationRequest {
    return SendAMessageInAConversationRequestFromJSONTyped(json, false);
}

export function SendAMessageInAConversationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendAMessageInAConversationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'],
    };
}

export function SendAMessageInAConversationRequestToJSON(json: any): SendAMessageInAConversationRequest {
    return SendAMessageInAConversationRequestToJSONTyped(json, false);
}

export function SendAMessageInAConversationRequestToJSONTyped(value?: SendAMessageInAConversationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
    };
}

